import TopicServices from '../../services/TopicServices';

// Action Types
export const TOPICS_ACTIONS = {
    SET_LOADING: 'TOPICS_SET_LOADING',
    SET_DATA: 'TOPICS_SET_DATA',
    SET_FILTERS: 'TOPICS_SET_FILTERS',
    SET_SEARCH: 'TOPICS_SET_SEARCH',
    SET_PAGE: 'TOPICS_SET_PAGE',
    SET_PAGE_SIZE: 'TOPICS_SET_PAGE_SIZE',
    SET_CATEGORY_FILTER: 'TOPICS_SET_CATEGORY_FILTER',
    SET_DATE_FILTER: 'TOPICS_SET_DATE_FILTER',
    CLEAR_FILTERS: 'TOPICS_CLEAR_FILTERS',
    SET_ERROR: 'TOPICS_SET_ERROR',
    RESET_STATE: 'TOPICS_RESET_STATE'
};

// Action Creators
export const setLoading = (loading) => ({
    type: TOPICS_ACTIONS.SET_LOADING,
    payload: loading
});

export const setData = (data, totalItems = 0) => ({
    type: TOPICS_ACTIONS.SET_DATA,
    payload: { data, totalItems }
});

export const setFilters = (filters) => ({
    type: TOPICS_ACTIONS.SET_FILTERS,
    payload: filters
});

export const setSearch = (search) => ({
    type: TOPICS_ACTIONS.SET_SEARCH,
    payload: search
});

export const setPage = (page) => ({
    type: TOPICS_ACTIONS.SET_PAGE,
    payload: page
});

export const setPageSize = (pageSize) => ({
    type: TOPICS_ACTIONS.SET_PAGE_SIZE,
    payload: pageSize
});

export const setCategoryFilter = (category) => ({
    type: TOPICS_ACTIONS.SET_CATEGORY_FILTER,
    payload: category
});

export const setDateFilter = (fromDate, toDate) => ({
    type: TOPICS_ACTIONS.SET_DATE_FILTER,
    payload: { fromDate, toDate }
});

export const clearFilters = () => ({
    type: TOPICS_ACTIONS.CLEAR_FILTERS
});

export const setError = (error) => ({
    type: TOPICS_ACTIONS.SET_ERROR,
    payload: error
});

export const resetState = () => ({
    type: TOPICS_ACTIONS.RESET_STATE
});

// Async Actions (Thunks)
export const fetchTopics = (customFilters = {}) => async (dispatch, getState) => {
    try {
        dispatch(setLoading(true));
        dispatch(setError(null));
        
        const { topics } = getState();
        const filters = { ...topics.filters, ...customFilters };
        
        // Build API parameters with exact field names required
        const apiParams = {};
        
        // Add search parameter if present
        if (filters.search && filters.search.trim() !== '') {
            apiParams.search = filters.search;
        }
        
        // Add category_id parameter if present
        if (filters.category) {
            apiParams.category_id = filters.category;
        }
        
        // Add date_from parameter if present
        if (filters.fromDate) {
            apiParams.date_from = filters.fromDate;
        }
        
        // Add date_to parameter if present
        if (filters.toDate) {
            apiParams.date_to = filters.toDate;
        }
        
        // Add has_contributions parameter if present
        if (filters.has_contributions !== null && filters.has_contributions !== undefined) {
            apiParams.has_contributions = filters.has_contributions;
        }
        
        // Add pagination parameters
        if (filters.page) {
            apiParams.page = filters.page;
        }
        
        if (filters.limit) {
            apiParams.limit = filters.limit;
        }
        
        const response = await TopicServices.get({...apiParams, public_view:true});
        
        if (response.success) {
            const data = response?.data?.view?.data || response?.data || [];
            const totalItems = response?.data?.view?.totalItems || response?.totalItems || 0;
            dispatch(setData(data, totalItems));
        } else {
            dispatch(setError(response.message || 'Failed to fetch topics'));
        }
    } catch (error) {
        dispatch(setError(error.message || 'An error occurred while fetching topics'));
    } finally {
        dispatch(setLoading(false));
    }
};

export const searchTopics = (searchTerm) => async (dispatch, getState) => {
    dispatch(setSearch(searchTerm));
    dispatch(setPage(1)); // Reset to first page when searching
    dispatch(fetchTopics());
};

export const updateFiltersAndFetch = (newFilters) => (dispatch) => {
    dispatch(setFilters(newFilters));
    dispatch(setPage(1)); // Reset to first page when filters change
    dispatch(fetchTopics());
};

export const changePage = (page) => (dispatch) => {
    dispatch(setPage(page));
    dispatch(fetchTopics());
};

export const changePageSize = (pageSize) => (dispatch) => {
    dispatch(setPageSize(pageSize));
    dispatch(setPage(1)); // Reset to first page when page size changes
    dispatch(fetchTopics());
};

export const applyDateFilter = (fromDate, toDate) => (dispatch) => {
    dispatch(setDateFilter(fromDate, toDate));
    dispatch(setPage(1)); // Reset to first page when filters change
    dispatch(fetchTopics());
};

export const applyCategoryFilter = (category) => (dispatch) => {
    dispatch(setCategoryFilter(category));
    dispatch(setPage(1)); // Reset to first page when filters change
    dispatch(fetchTopics());
};

export const resetFiltersAndFetch = () => (dispatch) => {
    dispatch(clearFilters());
    dispatch(fetchTopics());
};